<template>
    <div>     
    </div>
</template>

<script>

    import Helpers from "@/utilities/Helpers";

    export default {

        mixins: [Helpers],

        async created() {  

            this.showLoading();

            console.log('Logging out from Logout');
            await this.$store.dispatch("logInModule/Logout");
            this.$router.push('/login');


            this.hideLoading();
        }
    };
</script>